<mat-card appearance="outlined">
  @if (isLoading || isSaving) {
  <mat-progress-bar mode="buffer" color="primary"/>
  }
  <mat-card-header>
    <mat-card-title>Login Options</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form" class="flex-column gap-16">

      <mat-slide-toggle formControlName="phoneOtpEnabled">
        Phone OTP Enabled
      </mat-slide-toggle>

      <mat-slide-toggle formControlName="emailOtpEnabled">
        Email OTP Enabled
      </mat-slide-toggle>

      <mat-slide-toggle formControlName="emailPasswordEnabled">
        Email &amp; Password Enabled
      </mat-slide-toggle>

      <mat-slide-toggle formControlName="googleEnabled">
        Google Sign-In Enabled
      </mat-slide-toggle>

      <mat-slide-toggle formControlName="appleEnabled">
        Apple Sign-In Enabled
      </mat-slide-toggle>

      <mat-slide-toggle formControlName="batSsoEnabled">
        BAT SSO Enabled
      </mat-slide-toggle>

      @if (showDefaultLoginMethod) {
      <mat-form-field>
        <mat-label>Default Login Method</mat-label>
        <mat-select formControlName="defaultLoginMethod">
          @for (option of availableLoginMethodOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Allowed Country Codes (Phone OTP)</mat-label>
        <input matInput formControlName="allowedCountryCodes" placeholder="e.g. SG, PH, TH (leave empty to allow all)" />
        <mat-hint>Comma-separated ISO 3166-1 alpha-2 codes. Leave empty to allow all countries.</mat-hint>
      </mat-form-field>

      <div class="dialog-actions">
        <lib-button variant="raised" color="primary" [disabled]="isLoading || isSaving" (buttonClick)="onSave()">
          @if (isSaving) {
            <mat-spinner diameter="18" />
          }
          {{ isSaving ? 'Saving...' : 'Save' }}
        </lib-button>
      </div>

    </form>
  </mat-card-content>
</mat-card>
